<div class="accordian-container">

  @if (!readOnly && searchConfig) {
    <div class="search-container">
      <app-autocomplete-dropdown
        id="search-bar"
        class="autocomplete-dropdown"
        [placeholder]="searchConfig?.searchPlaceholder"
        [apiUrl]="searchConfig?.apiUrl"
        [selectFields]="searchConfig?.selectFields"
        [filterByKeys]="searchConfig.filterByKeys"
        [limit]="10"
        [orderBy]="searchConfig.orderBy"
        [bindLabel]="searchConfig.bindLabel"
        [bindValue]="searchConfig.bindValue"
        [displayColumns]="searchConfig.displayColumns"
        [additionalFilters]="searchConfig?.additionalFilters"
        [clientSideSearch]="searchConfig?.clientSideSearch"
        [clientSearchData]="searchConfig?.clientSearchData"
        [(ngModel)]="searchText"
        (suggestionSelected)="onSuggestionSelected($event)"
      >
      </app-autocomplete-dropdown>
      <button type="button" class="add-button secondary_button" [disabled]="disableAddButton" (click)="addItem()">
        <app-svg-icon class="image-icon"
                      [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
        <span>Add</span>
      </button>
    </div>
  }

  <div class="table-container">
    <table class="accordion-table table-view-data">
      <thead>
        <tr #headerRow class="header-row">

          <th class="icon-cell expand-cell"></th>

          @if (!readOnly) {
            <th class="checkbox-cell">
              <input type="checkbox">
            </th>
          } @else {
            <th class="sl-no-cell">
              <span>Sl No.</span>
            </th>
          }
          @for (header of tableHeaderAndData.headers; track $index) {
            <th class="header-cell" [ngStyle]="{ display: header.hidden ? 'none' : 'table-cell' }">{{ header.displayName }}</th>
          }
          @if (!readOnly) {
            <th class="icon-cell"></th>
          }
        </tr>
      </thead>

      <!-- Body -->
      <tbody [class.no-hover]="!tableHeaderAndData?.data?.length">

        @if (tableHeaderAndData.data.length === 0) {
          <tr>
            <td [attr.colspan]="totalColspan">
              <app-no-data [msg]="noDataMsg" [path]="noDataIconPath"></app-no-data>
            </td>
          </tr>
        } @else {

          @for (data of tableHeaderAndData.data; track $index; let i=$index) {
            <tr class="data-row" [class.expanded]="expandedRowIndex === i" (click)="toggleRow(i)" (keydown.enter)="toggleRow(i)">

              <td class="icon-cell expand-cell">
                <div class="icon-wrapper">
                  <app-svg-icon
                    [path]="expandedRowIndex === i ? 'assets/icons/chevron_up.svg' : 'assets/icons/chevron_down.svg'"
                    class="icon"
                  ></app-svg-icon>
                </div>
              </td>

              @if (!readOnly) {
                <td class="checkbox-cell">
                  <input type="checkbox" (click)="$event.stopPropagation()">
                </td>
              } @else {
                <td class="sl-no-cell">
                  {{ i + 1 }}
                </td>
              }
              @for (header of tableHeaderAndData.headers; track $index) {
                <td class="data-cell" [ngStyle]="{ display: header.hidden ? 'none' : 'table-cell' }">
                  {{ formatCellDate(data[header.fieldName], header) }}
                </td>
              }
              @if (!readOnly) {
                <td class="icon-cell">
                  <div class="icon-wrapper">
                    <app-svg-icon class="delete-icon"
                                  [path]="'assets/icons/delete_icon.svg'"
                                  (click)="deleteItem(i); $event.stopPropagation()"
                    ></app-svg-icon>
                  </div>
                </td>
              }
            </tr>

            <tr class="expanded-content" [class.expanded]="expandedRowIndex === i">
              <td [attr.colspan]="totalColspan">
                <ng-template #accordionContent></ng-template>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

</div>

